import InfiniteLoopScroll from "common/components/InfiniteLoopScroll/InfiniteLoopScroll"
import { clearNewDocumentoSettingsState } from "features/Crear/redux/slices/newDocumentoSettingsSlice"
import {
  clearNewDocumentoState,
  stateConvertirNextDoc,
} from "features/Crear/redux/slices/newDocumentoSlice"
import { useDispatch } from "hooks/useDispatch"
import { useEffect } from "react"
import { useTranslation } from "react-i18next"
import DirectAccessCard from "./DirectAccessCard"
import SectionHeaderComponent from "./SectionHeaderComponent"

const SectionComponent = ({
  items,
  value,
  handleFilter,
  documentIsReady,
  handleClick,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  useEffect(() => {
    // @ts-expect-error TS(2554): Expected ...
    dispatch(stateConvertirNextDoc(true))
    dispatch(clearNewDocumentoState())
    // @ts-expect-error TS(2554): Expected ...
    dispatch(clearNewDocumentoSettingsState())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {items?.map((menu: $TSMigrationFixMe) => (
        <div
          key={menu.key}
          className='mt-5'
        >
          <SectionHeaderComponent
            title={menu.title}
            value={value}
            handleFilter={handleFilter}
            t={t}
          />
          <InfiniteLoopScroll documentIsReady={documentIsReady}>
            {menu.subMenu.map((sub: $TSMigrationFixMe) => (
              <div
                key={sub.key}
                onClick={() => handleClick(sub.path)}
              >
                <DirectAccessCard content={sub} />
              </div>
            ))}
          </InfiniteLoopScroll>
        </div>
      ))}
    </>
  )
}

export default SectionComponent
